import { storageCurrency } from '@/utils/currency';

export default {
  data: () => ({
    currency: false,
  }),

  methods: {
    changeCurrency(value) {
      storageCurrency.set(value);
      this.currency = value;
    },
  },

  created() {
    const currency = storageCurrency.get();

    if (typeof currency === 'boolean') {
      this.currency = currency;
    }
  },
};
